export default __webpack_public_path__ + "static/media/masterDataIcon.16953b27.svg";